import { Subject, takeUntil } from 'rxjs';
import { Component, ElementRef, Input, OnInit, ViewChild, ChangeDetectionStrategy, DestroyRef, inject } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { AbstractControl, NgForm, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import Decimal from 'decimal.js';
import moment from 'moment';
import "moment-timezone";
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { BroadcastService, HttpService, MessageService, UserService } from 'src/app/core';
import { ConstantConfig } from 'src/app/core/config/constant.config';
import { MsgConstantConfig } from 'src/app/core/config/message.constant.config';
import { PathConfig } from 'src/app/core/config/path.config';
import { Utility } from 'src/app/core/utils/utility';
import { QueueDetailServiceService } from '../queue-detail-service.service';
@Component({
  selector: 'app-take-payment',
  templateUrl: './take-payment.component.html',
  styleUrls: ['./take-payment.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  providers: [CurrencyPipe]
})

export class TakePaymentComponent implements OnInit {
  private readonly destroy$ = new Subject<void>();

  private readonly destroyRef = inject(DestroyRef);


  @Input() loanDetail!: any;
  @Input() loanID!: any;
  @Input() id!: any;
  @Input() editMode!: boolean;
  @Input() transactionDetails!: any;
  @Input() previousTransaction!: any;
  submitted: boolean = false;
  isManualTakePayment: boolean = false;
  loanTransactionDetails!: any;
  paymentCodeList: any;
  paymentMethodList: any;
  isButtonEnabled: boolean = false;
  selectedPaymentCode: any = null;
  isChargedOFF: boolean = false;

  balanceAfter: any = {
    principal_payment: 0,
    interest_payment: 0,
    late_fees_payment: 0,
    nsf_fees_payment: 0,
    other_fees_payment: 0,
    tax_payment: 0,
    down_payment: 0,
    total_payment: 0
  }

  @ViewChild('paymentForm') formElement!: NgForm;
  takePaymentForm!: UntypedFormGroup
  isDirty: boolean = false;
  @ViewChild('totalFee') totalFee!: ElementRef;
  isOverAmount: boolean = false;
  isAmountValueExist: boolean = true;
  codetype: string = '';
  current_date: string = '';
  isFutureDate: boolean = false;
  disablePastDate: boolean = false;
  @Input() standardSettingsData: any
  @Input() clientDetailService: any;
  salesTaxNotAllowed: boolean = false;
  paymentAmountLimit = 100000000//100M(100,000,000.00);
  private readonly principalBalanceUpperLimit = 100000000;
  isApprove: boolean = false;
  isApproveWarningMessage2: boolean = false;
  isShowWarning: boolean = false;
  isIncompleteNegativePaymentAmount: boolean = false;
  incompleteNegativeBreakdownInputs: { [key: string]: boolean } = {};
  previousTransactionDataByDate: any = null;
  initialPaymentEffectiveDate: string = '';
  private effectiveDateRequestId: number = 0;
  DATE_FORMAT_MMDDYYYY = ConstantConfig.DATE_FORMAT_MMDDYYYY;
  warningMessage: string = '';
  warningMessage2: string = '';
  isLoadingEffectiveDateBalances: boolean = false;
  isEffectiveDateChangedInEditMode: boolean = false;
  private readonly effectiveDateChangedWarningKey = "Since you are changing the transaction's Effective Date, the transaction's before and after balances will be recalculated. As a result, some balances may change or become negative. Please review the updated balances after posting the transaction.";
  readonly manualPaymentFieldArray = ['principal_payment', 'interest_payment', 'late_fees_payment', 'nsf_fees_payment', 'other_fees_payment', 'tax_payment', 'down_payment', 'total_payment'];

  constructor(
    private httpService: HttpService,
    private msgService: MessageService,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private broadCastService: BroadcastService,
    private userService: UserService,
    private queueDetailService: QueueDetailServiceService,
    private translateService: TranslateService,
    private currencyPipe: CurrencyPipe
  ) {

    this.codetype = this.isSpecialPermission();


  }

  ngOnInit(): void {
    this.current_date = moment(new Date()).tz('America/Los_Angeles').format("YYYY-MM-DD");
    this.initialPaymentEffectiveDate = this.normalizeEffectiveDate(this.current_date);

    if (this.editMode) {
      this.takePaymentForm = new UntypedFormGroup({
        payment_info_code_id: new UntypedFormControl(null, [Validators.required]),
        payment_effective_date: new UntypedFormControl(this.current_date, [Validators.required]),

        payment_method_id: new UntypedFormControl(null, [Validators.required]),
        payment_amount: new UntypedFormControl(null, [Validators.required, this.currencyRangeValidator(this.paymentAmountLimit, "payment_amount"), this.breakdownValidator(() => this.isManualTakePayment, () => this.isManualBreakdownAllowed()), this.principalBalanceLimitValidator(false)]),
        posting_method: new UntypedFormControl(null, [Validators.required]),
        reference_note: new UntypedFormControl('', [Validators.maxLength(200), Validators.pattern('^(?!\\s*$).+'), Validators.minLength(4)]),
        principal_payment: new UntypedFormControl('0.00', [Validators.required, this.currencyRangeValidator(this.paymentAmountLimit), this.balanceAfterRangeValidator('principal_payment').bind(this), this.amountSignValidator(), this.principalBalanceLimitValidator(true)]),
        interest_payment: new UntypedFormControl('0.00', [Validators.required, this.currencyRangeValidator(this.paymentAmountLimit), this.balanceAfterRangeValidator('interest_payment').bind(this), this.amountSignValidator()]),
        late_fees_payment: new UntypedFormControl('0.00', [Validators.required, this.feesRangeValidator(this.paymentAmountLimit), this.balanceAfterRangeValidator('late_fees_payment').bind(this), this.amountSignValidator()]),
        nsf_fees_payment: new UntypedFormControl('0.00', [Validators.required, this.feesRangeValidator(this.paymentAmountLimit), this.balanceAfterRangeValidator('nsf_fees_payment').bind(this), this.amountSignValidator()]),
        other_fees_payment: new UntypedFormControl('0.00', [Validators.required, this.feesRangeValidator(this.paymentAmountLimit), this.balanceAfterRangeValidator('other_fees_payment').bind(this), this.amountSignValidator()]),
        tax_payment: new UntypedFormControl('0.00', [Validators.required, this.feesRangeValidator(this.paymentAmountLimit), this.balanceAfterRangeValidator('tax_payment').bind(this), this.amountSignValidator()]),
        down_payment: new UntypedFormControl('0.00', [Validators.required, this.feesRangeValidator(this.paymentAmountLimit), this.balanceAfterRangeValidator('down_payment').bind(this), this.amountSignValidator()]),
        total_payment: new UntypedFormControl('0.00', [Validators.required]),
        payment_edit_reason: new UntypedFormControl('', [Validators.required, Validators.maxLength(100), Validators.pattern('^(?!\\s*$).+'), Validators.minLength(4)]),
        payment_received_method: new UntypedFormControl('RECEIVED_IN_MAIL', []),
      })
    }

    if (!this.editMode) {
      this.takePaymentForm = new UntypedFormGroup({
        payment_info_code_id: new UntypedFormControl(null, [Validators.required]),
        payment_effective_date: new UntypedFormControl(this.current_date, [Validators.required]),
        payment_method_id: new UntypedFormControl(null, [Validators.required]),
        payment_amount: new UntypedFormControl(null, [Validators.required, this.currencyRangeValidator(this.paymentAmountLimit, "payment_amount"), this.breakdownValidator(() => this.isManualTakePayment, () => this.isManualBreakdownAllowed()), this.principalBalanceLimitValidator(false)]),
        posting_method: new UntypedFormControl(null, [Validators.required]),
        reference_note: new UntypedFormControl('', [Validators.maxLength(200), Validators.pattern('^(?!\\s*$).+'), Validators.minLength(4)]),
        principal_payment: new UntypedFormControl('0.00', [Validators.required, this.currencyRangeValidator(this.paymentAmountLimit), this.balanceAfterRangeValidator('principal_payment').bind(this), this.amountSignValidator(), this.principalBalanceLimitValidator(true)]),
        interest_payment: new UntypedFormControl('0.00', [Validators.required, this.currencyRangeValidator(this.paymentAmountLimit), this.balanceAfterRangeValidator('interest_payment').bind(this), this.amountSignValidator()]),
        late_fees_payment: new UntypedFormControl('0.00', [Validators.required, this.feesRangeValidator(this.paymentAmountLimit), this.balanceAfterRangeValidator('late_fees_payment').bind(this), this.amountSignValidator()]),
        nsf_fees_payment: new UntypedFormControl('0.00', [Validators.required, this.feesRangeValidator(this.paymentAmountLimit), this.balanceAfterRangeValidator('nsf_fees_payment').bind(this), this.amountSignValidator()]),
        other_fees_payment: new UntypedFormControl('0.00', [Validators.required, this.feesRangeValidator(this.paymentAmountLimit), this.balanceAfterRangeValidator('other_fees_payment').bind(this), this.amountSignValidator()]),
        tax_payment: new UntypedFormControl('0.00', [Validators.required, this.feesRangeValidator(this.paymentAmountLimit), this.balanceAfterRangeValidator('tax_payment').bind(this), this.amountSignValidator()]),
        down_payment: new UntypedFormControl('0.00', [Validators.required, this.feesRangeValidator(this.paymentAmountLimit), this.balanceAfterRangeValidator('down_payment').bind(this), this.amountSignValidator()]),
        total_payment: new UntypedFormControl('0.00', [Validators.required]),
        payment_edit_reason: new UntypedFormControl(''),
        payment_received_method: new UntypedFormControl('RECEIVED_IN_MAIL', []),
      })
    }

    this.takePaymentForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((e) => {
      this.isDirty = true;
      if (!this.isManualBreakdownValidationEnabled()) {
        this.isOverAmount = false;
        // Principal-limit visibility depends on non-value gates too, so re-run it when manual mode toggles off.
        this.refreshPrincipalLimitValidation();
        return;
      }
      let total = this.getTotal();
      this.isOverAmount = !this.areAmountsEqual(this.takePaymentForm.get('payment_amount')?.value, total);
      // Keep the footer error in sync when only the breakdown-total gate changes.
      this.refreshPrincipalLimitValidation();
    });

    this.getPaymentCode();
    this.getPaymentMethod();
    this.getLoanTransactionDetails();
    this.takePaymentForm.controls.payment_amount.valueChanges
      .pipe(distinctUntilChanged()).pipe(takeUntil(this.destroy$)).subscribe((e) => {
        this.manualPaymentFieldArray.forEach(field => {
          this.takePaymentForm.get(field)?.updateValueAndValidity();
        });
        if (this.isApprove) {
          this.isApprove = false;
        }
        this.validateAmountForWarning();//for warning allow after checkbox checked or approved
      });


    this.takePaymentForm.controls.payment_effective_date.valueChanges
      .pipe(distinctUntilChanged()).pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        this.getDif(value);

        const effectiveDateControl = this.takePaymentForm.controls.payment_effective_date;
        if (!effectiveDateControl?.dirty || !effectiveDateControl?.value) {
          return;
        }

        this.isLoadingEffectiveDateBalances = true;
        this.isShowWarning = false;
        this.warningMessage = '';
        this.isApprove = false;
        this.warningMessage2 = '';
        this.isApproveWarningMessage2 = false;
      });

    this.takePaymentForm.controls.payment_effective_date.valueChanges
      .pipe(debounceTime(400), distinctUntilChanged()).pipe(takeUntil(this.destroy$))
      .subscribe(async (value) => {
        const requestId = ++this.effectiveDateRequestId;
        this.previousTransactionDataByDate = null;
        this.isLoadingEffectiveDateBalances = false;
        this.refreshBalanceAfter();
        this.warningMessage2 = '';
        this.isApproveWarningMessage2 = false;
        this.isShowWarning = false;
        this.warningMessage = '';
        this.isApprove = false;

        if (!value || !this.isValidDate(value)) {
          this.isFutureDate = false;
          this.disablePastDate = false;
          this.warningMessage = '';
          this.isApprove = false;
          this.isShowWarning = false;
          return;
        }

        if (!this.isFutureDate && !this.disablePastDate) {
          this.updateEffectiveDateChangeWarning(value);
          if (this.normalizeEffectiveDate(value) === this.initialPaymentEffectiveDate) {
            this.isLoadingEffectiveDateBalances = false;
            this.checkBalanceAfter();
            this.validateAmountForWarning(value);
            return;
          }

          this.isLoadingEffectiveDateBalances = true;
          try {
            await this.getPreviousTransactionByEffectiveDate(value, requestId);
            if (requestId === this.effectiveDateRequestId) {
              this.isLoadingEffectiveDateBalances = false;
              this.checkBalanceAfter();
              this.validateAmountForWarning(value);
            }
          } catch (_err) {
            if (requestId === this.effectiveDateRequestId) {
              this.isLoadingEffectiveDateBalances = false;
              this.checkBalanceAfter();
            }
          }
        } else {
          this.isLoadingEffectiveDateBalances = false;
        }
      });
  }

  getFirstTransactionDate() {
    const url = `${PathConfig.LOANS}/${this.loanID}`;
    this.httpService.get(url).subscribe((res) => {
      this.loanTransactionDetails.import_transaction_date = res?.import_transaction_date ?? '';
    })
  }

  //function To Validate Payment Effective Date with 1st import date and future dates
  getDif(effdate: string) {
    if (!effdate) {
      this.isFutureDate = false;
      this.disablePastDate = false;
      this.refreshPrincipalLimitValidation();
      return;
    }

    let firstImportDate = 0;
    let today = moment.tz("America/Los_Angeles").format('YYYY-MM-DD');
    let tod = Date.parse(today?.toString());
    let dpast = tod;
    let selectedDate = Date.parse(effdate);

    if (this.previousTransaction?.import_transaction_date) {

      dpast = Date.parse(this.previousTransaction?.import_transaction_date);
      let dpastTimeStamp = moment(new Date((dpast)))?.tz('America/Los_Angeles')?.format("YYYY-MM-DD");
      firstImportDate = new Date(dpastTimeStamp)?.getTime();
    }

    if (selectedDate > tod) {

      this.isFutureDate = true;
      this.disablePastDate = false;
    }
    //converting selected date to PST for comparing
    else if (firstImportDate > (selectedDate - 1000 * 60 * 60 * 8)) {

      this.isFutureDate = false;
      this.disablePastDate = true;
    }
    else {

      this.isFutureDate = false;
      this.disablePastDate = false;
    }
    if (this.previousTransaction?.import_transaction_date?.split(' ')[0] == effdate) {
      this.disablePastDate = false;
    }
    this.refreshPrincipalLimitValidation();
  }

  isSpecialPermission(): string {

    let codeType = '';
    const permisions: Array<any> = this.userService.PERMISSIONS;
    permisions.forEach((item: string) => {
      const modulePermission = `specialpermission:post_payment`
      if (item.indexOf(modulePermission) > - 1) {
        if (item.indexOf('NON_CASH_PAYMENTS_ONLY') > -1)
          codeType = "NON-CASH";
        else if (item.indexOf('CASH_PAYMENTS_ONLY') > -1)
          codeType = "CASH";
        else if (item.indexOf('YES') > -1)
          codeType = "YES";
        else
          codeType = "NO";
      }

    });
    return codeType;
  }

  // get payment Info codes
  getPaymentCode() {
    const url = `${PathConfig.PAYMENT_INFO_CODES}`;
    this.httpService.get(url).subscribe((res) => {

      let resp = res.filter((item: any) => {
        return item.status === 'ACTIVE';
      });

      this.paymentCodeList = this.codetype == 'YES' ? resp : resp?.filter((item: any) => {
        return item.code_type === this.codetype;
      });
      if (this.editMode) {
        this.paymentCodeList = resp;
        if (this.takePaymentForm) {
          this.customValidators();
        }
      }
    });
  }

  // get payment methods  
  getPaymentMethod() {
    const url = `${PathConfig.PAYMENT_METHODS}`;
    this.httpService.get(url).subscribe((res) => {
      this.paymentMethodList = res;
    })
  }

  //get loan transaction details for edit mode
  getLoanTransactionDetails() {
    this.isManualTakePayment = (this.transactionDetails?.default_breakdown == "NO" ? true : false);
    if (this.editMode) {
      this.isManualTakePayment = (this.transactionDetails?.payment_info_code?.slug == "WAIVE" ? true : this.isManualTakePayment);


      this.loanTransactionDetails = this.transactionDetails;
      if (this.loanTransactionDetails) {
        if (this.loanTransactionDetails?.payment_info_code?.id) {
          this.loanTransactionDetails.payment_info_code_id = this.loanTransactionDetails?.payment_info_code?.id;
        } else {
          this.loanTransactionDetails.payment_info_code_id = null;
        }
        if (this.loanTransactionDetails?.payment_method?.id) {
          this.loanTransactionDetails.payment_method_id = this.loanTransactionDetails?.payment_method?.id;
        } else {
          this.loanTransactionDetails.payment_method_id = null;
        }
      }

      if (this.loanTransactionDetails.payment_amount != '' && this.loanTransactionDetails.payment_amount != null) { (this.loanTransactionDetails.payment_amount = parseFloat(this.loanTransactionDetails.payment_amount).toFixed(2)); }
      else { this.loanTransactionDetails.payment_amount = '0.00'; }
      if (this.loanTransactionDetails.principal_payment != '' && this.loanTransactionDetails.principal_payment != null) { (this.loanTransactionDetails.principal_payment = parseFloat(this.loanTransactionDetails.principal_payment).toFixed(2)); }
      else { this.loanTransactionDetails.principal_payment = '0.00'; }
      if (this.loanTransactionDetails.interest_payment != '' && this.loanTransactionDetails.interest_payment != null) { (this.loanTransactionDetails.interest_payment = parseFloat(this.loanTransactionDetails.interest_payment).toFixed(2)); }
      else { this.loanTransactionDetails.interest_payment = '0.00'; }
      if (this.loanTransactionDetails.late_fees_payment != '' && this.loanTransactionDetails.late_fees_payment != null) { (this.loanTransactionDetails.late_fees_payment = parseFloat(this.loanTransactionDetails.late_fees_payment).toFixed(2)); }
      else { this.loanTransactionDetails.late_fees_payment = '0.00'; }
      if (this.loanTransactionDetails.nsf_fees_payment != '' && this.loanTransactionDetails.nsf_fees_payment != null) { (this.loanTransactionDetails.nsf_fees_payment = parseFloat(this.loanTransactionDetails.nsf_fees_payment).toFixed(2)); }
      else { this.loanTransactionDetails.nsf_fees_payment = '0.00'; }
      if (this.loanTransactionDetails.other_fees_payment != '' && this.loanTransactionDetails.other_fees_payment != null) { (this.loanTransactionDetails.other_fees_payment = parseFloat(this.loanTransactionDetails.other_fees_payment).toFixed(2)); }
      else { this.loanTransactionDetails.other_fees_payment = '0.00'; }
      if (this.loanTransactionDetails.tax_payment != '' && this.loanTransactionDetails.tax_payment != null) { (this.loanTransactionDetails.tax_payment = parseFloat(this.loanTransactionDetails.tax_payment).toFixed(2)); }
      else { this.loanTransactionDetails.tax_payment = '0.00'; }
      if (this.loanTransactionDetails.down_payment != '' && this.loanTransactionDetails.down_payment != null) { (this.loanTransactionDetails.down_payment = parseFloat(this.loanTransactionDetails.down_payment).toFixed(2)); }
      else { this.loanTransactionDetails.down_payment = '0.00'; }
      if (this.loanTransactionDetails.total_payment != '' && this.loanTransactionDetails.total_payment != null) { (this.loanTransactionDetails.total_payment = parseFloat(this.loanTransactionDetails.total_payment).toFixed(2)); }
      else { this.loanTransactionDetails.total_payment = '0.00'; }

      this.initialPaymentEffectiveDate = this.normalizeEffectiveDate(this.loanTransactionDetails?.payment_effective_date);
      this.takePaymentForm.patchValue(this.loanTransactionDetails);

      let effectivedate;
      if (![null, undefined, ''].includes(this.loanTransactionDetails?.payment_effective_date) && this.loanTransactionDetails?.payment_info_code?.slug == 'WAIVE') {
        var temp_date = moment(this.loanTransactionDetails?.payment_effective_date, 'YYYY-MM-DD');
        effectivedate = temp_date?.format('MM/DD/YYYY') ?? '';
        this.takePaymentForm.patchValue({ payment_effective_date: effectivedate });
        this.takePaymentForm.updateValueAndValidity();
      }

      const url = `${PathConfig.LOANS}/${this.loanID}`;
      this.httpService.get(url).subscribe((res) => {
        this.loanDetail = res;

        this.isChargedOFF = this.loanDetail?.status == 'CHARGED-OFF' ? true : false;

        this.takePaymentForm?.controls?.payment_amount?.clearValidators();
        this.takePaymentForm?.controls?.payment_amount?.setValidators([Validators.required, this.currencyRangeValidator(this.paymentAmountLimit, "payment_amount"), this.breakdownValidator(() => this.isManualTakePayment, () => this.isManualBreakdownAllowed()), this.principalBalanceLimitValidator(false)]);

        this.balanceAfter.principal_payment = parseFloat((this.previousTransaction?.remaining_principal_balance - this.loanTransactionDetails?.principal_payment).toFixed(2));
        this.balanceAfter.interest_payment = parseFloat((this.previousTransaction?.remaining_interest_balance - this.loanTransactionDetails?.interest_payment).toFixed(2));
        this.balanceAfter.late_fees_payment = parseFloat((this.previousTransaction?.remaining_late_fees_balance - this.loanTransactionDetails?.late_fees_payment).toFixed(2));
        this.balanceAfter.nsf_fees_payment = parseFloat((this.previousTransaction?.remaining_nsf_fees_balance - this.loanTransactionDetails?.nsf_fees_payment).toFixed(2));
        this.balanceAfter.other_fees_payment = parseFloat((this.previousTransaction?.remaining_other_fees_balance - this.loanTransactionDetails?.other_fees_payment).toFixed(2));
        this.balanceAfter.tax_payment = parseFloat((this.previousTransaction?.remaining_tax_balance - this.loanTransactionDetails?.tax_payment).toFixed(2));
        this.balanceAfter.down_payment = parseFloat((this.previousTransaction?.remaining_down_payment_balance - this.loanTransactionDetails?.down_payment).toFixed(2));

        // Re-evaluate validators and enabled state once loan detail is available.
        this.customValidators();
        this.manageValidators();
        this.checkMainAmount();

        this.takePaymentForm?.controls?.payment_amount?.updateValueAndValidity();
        this.checkIfNegativeBalanceAfter();
      })
    } else {
      this.balanceAfter.principal_payment = parseFloat((this.previousTransaction?.remaining_principal_balance).toFixed(2));
      this.balanceAfter.interest_payment = parseFloat((this.previousTransaction?.remaining_interest_balance).toFixed(2));
      this.balanceAfter.late_fees_payment = parseFloat((this.previousTransaction?.remaining_late_fees_balance).toFixed(2));
      this.balanceAfter.nsf_fees_payment = parseFloat((this.previousTransaction?.remaining_nsf_fees_balance).toFixed(2));
      this.balanceAfter.other_fees_payment = parseFloat((this.previousTransaction?.remaining_other_fees_balance).toFixed(2));
      this.balanceAfter.tax_payment = parseFloat((this.previousTransaction?.remaining_tax_balance).toFixed(2));
      this.balanceAfter.down_payment = parseFloat((this.previousTransaction?.remaining_down_payment_balance).toFixed(2));

      const url = `${PathConfig.LOANS}/${this.loanID}`;
      this.httpService.get(url).subscribe((res) => {
        this.loanTransactionDetails = res;
      })
      this.checkIfNegativeBalanceAfter();
    }
    this.checkBalanceAfter();
    this.checkMainAmount();
    if (this.loanTransactionDetails?.posting_method) {
      this.takePaymentForm.patchValue({ posting_method: this.loanTransactionDetails?.posting_method ?? null });
    }
    this.onPaymentInfoCodeChange();
  }

  toggleTakeMethodType() {
    this.isManualTakePayment = !this.isManualTakePayment;
    (this.formElement as any).submitted = false;
    this.takePaymentForm.get('payment_amount')?.updateValueAndValidity();
    this.manageValidators();
    this.checkMainAmount();
    this.refreshBalanceAfter();
    this.takePaymentForm.markAsDirty();
  }

  checkMainAmount(event?: any) {
    const control = this.takePaymentForm.get('payment_amount');
    const rawValue = String(event?.target?.value ?? control?.value ?? '');
    const normalizedValue = this.normalizeCurrencyInputValue(rawValue, 'amount');
    const target = event?.target as HTMLInputElement | null;
    const hasBlurEvent = !!target;
    const parsedValue = this.getNumericInputValue(normalizedValue);
    const isNumericValue = normalizedValue !== '' && Number.isFinite(Number(normalizedValue));

    this.isIncompleteNegativePaymentAmount = normalizedValue === '-';

    if (normalizedValue === '-') {
      if (hasBlurEvent) {
        if (target && target.value !== '') {
          target.value = '';
        }
        control?.setValue('', { emitEvent: false });
      }
      control?.updateValueAndValidity({ emitEvent: false });
      this.isAmountValueExist = false;
      this.disableBreakdownFields();
      this.isOverAmount = false;
      this.takePaymentForm.controls.total_payment.markAsTouched();
      return;
    }

    if (rawValue === '' && !hasBlurEvent) {
      if (control?.value !== '') {
        control?.setValue('', { emitEvent: false });
      }
      control?.updateValueAndValidity({ emitEvent: false });
      this.isAmountValueExist = false;
      this.disableBreakdownFields();
      this.isOverAmount = false;
      this.takePaymentForm.controls.total_payment.markAsTouched();
      return;
    }

    const formattedValue = parsedValue === null
      ? (rawValue === '0' || rawValue === '0.00' ? '0.00' : '')
      : this.checkForNan(parsedValue, 'payment_amount') ?? '0.00';
    if (target && target.value !== formattedValue) {
      target.value = formattedValue;
    }
    control?.setValue(formattedValue, { emitEvent: false });
    control?.updateValueAndValidity({ emitEvent: false });

    this.isAmountValueExist = isNumericValue && Number(normalizedValue) !== 0;
    if (this.isAmountValueExist && this.isManualBreakdownValidationEnabled()) {
      this.takePaymentForm.get('principal_payment')?.enable();
      this.takePaymentForm.get('interest_payment')?.enable();
      this.takePaymentForm.get('late_fees_payment')?.enable();
      this.takePaymentForm.get('nsf_fees_payment')?.enable();
      this.takePaymentForm.get('other_fees_payment')?.enable();
      this.takePaymentForm.get('tax_payment')?.enable();
      this.takePaymentForm.get('down_payment')?.enable();
    } else {
      this.disableBreakdownFields();
    }
    if (this.isManualBreakdownValidationEnabled()) {
      let total = this.getTotal();
      this.isOverAmount = !this.areAmountsEqual(this.takePaymentForm.get('payment_amount')?.value, total);
      this.takePaymentForm.controls.total_payment.markAsTouched();
    } else {
      this.isOverAmount = false;
    }

    this.refreshPrincipalLimitValidation();
  }

  onPaymentAmountInput(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const rawValue = inputElement.value ?? '';
    const normalizedValue = this.normalizeCurrencyInputValue(rawValue, 'amount');
    this.isIncompleteNegativePaymentAmount = normalizedValue === '-';

    if (inputElement.value !== normalizedValue) {
      inputElement.value = normalizedValue;
    }

    this.takePaymentForm.get('payment_amount')?.setValue(normalizedValue, { emitEvent: false });

    const isNumericValue = normalizedValue !== '' && Number.isFinite(Number(normalizedValue));
    this.isAmountValueExist = isNumericValue && Number(normalizedValue) !== 0;
    if (this.isAmountValueExist && this.isManualBreakdownValidationEnabled()) {
      this.takePaymentForm.get('principal_payment')?.enable();
      this.takePaymentForm.get('interest_payment')?.enable();
      this.takePaymentForm.get('late_fees_payment')?.enable();
      this.takePaymentForm.get('nsf_fees_payment')?.enable();
      this.takePaymentForm.get('other_fees_payment')?.enable();
      this.takePaymentForm.get('tax_payment')?.enable();
      this.takePaymentForm.get('down_payment')?.enable();
    } else {
      this.disableBreakdownFields();
    }
    this.takePaymentForm.get('payment_amount')?.updateValueAndValidity({ emitEvent: false });
  }

  calculateBalance(event: Event) {
    const target = event.target as HTMLInputElement | null;
    const fieldName = target?.getAttribute('name');
    if (!fieldName || !target) {
      return;
    }

    const control = this.takePaymentForm.get(fieldName);
    const rawValue = target.value ?? '';
    const parsedValue = this.getNumericInputValue(rawValue);
    const formattedValue = parsedValue === null ? this.checkForNan(0) : this.checkForNan(parsedValue);
    const safeFormattedValue = formattedValue ?? '0.00';

    if (target.value !== safeFormattedValue) {
      target.value = safeFormattedValue;
    }

    if (control) {
      control.setValue(safeFormattedValue, { emitEvent: false });
    }

    this.incompleteNegativeBreakdownInputs[fieldName] = false;
    control?.updateValueAndValidity({ onlySelf: true });

    const paymentAmount = Number(String(this.takePaymentForm.get('payment_amount')?.value ?? 0).replace(/,/g, ''));
    if (paymentAmount > 0 && Number.isFinite(Number(parsedValue)) && Number(parsedValue) < 0) {
      control?.setErrors({
        ...(control.errors ?? {}),
        invalidPaymentSign: {
          message: this.translateService.instant('Value must be positive when payment amount is positive')
        }
      });
    }

    this.refreshBalanceAfter({ [fieldName]: safeFormattedValue });
  }

  onManualBreakdownInput(fieldName: string, event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const rawValue = inputElement.value ?? '';
    const normalizedValue = this.normalizeBreakdownInputValue(rawValue);
    const control = this.takePaymentForm.get(fieldName);
    const paymentAmount = Number(String(this.takePaymentForm.get('payment_amount')?.value ?? 0).replace(/,/g, ''));

    if (inputElement.value !== normalizedValue) {
      inputElement.value = normalizedValue;
    }

    if (control) {
      control.setValue(normalizedValue, { emitEvent: false });
    }

    this.incompleteNegativeBreakdownInputs[fieldName] = normalizedValue === '-';
    control?.updateValueAndValidity({ onlySelf: true });

    if (paymentAmount > 0 && Number.isFinite(Number(normalizedValue)) && Number(normalizedValue) < 0) {
      control?.setErrors({
        ...(control.errors ?? {}),
        invalidPaymentSign: {
          message: this.translateService.instant('Value must be positive when payment amount is positive')
        }
      });
    }

    this.refreshBalanceAfter({ [fieldName]: normalizedValue });
  }

  private disableBreakdownFields(): void {
    this.takePaymentForm.get('principal_payment')?.disable();
    this.takePaymentForm.get('interest_payment')?.disable();
    this.takePaymentForm.get('late_fees_payment')?.disable();
    this.takePaymentForm.get('nsf_fees_payment')?.disable();
    this.takePaymentForm.get('other_fees_payment')?.disable();
    this.takePaymentForm.get('tax_payment')?.disable();
    this.takePaymentForm.get('down_payment')?.disable();
  }

  private normalizeCurrencyInputValue(value: string, inputType: 'breakdown' | 'amount' = 'breakdown'): string {
    const rawValue = String(value ?? '').trim();

    if (!rawValue || rawValue === '-') {
      return rawValue;
    }

    const sanitizedValue = rawValue.replace(/[^0-9,.-]/g, '');
    if (!sanitizedValue) {
      return '';
    }

    const hasLeadingMinus = sanitizedValue.startsWith('-');
    const withoutSign = hasLeadingMinus ? sanitizedValue.slice(1) : sanitizedValue;
    const [integerPartRaw = '', ...decimalParts] = withoutSign.split('.');
    const integerDigits = integerPartRaw.replace(/,/g, '').slice(0, inputType === 'amount' ? 9 : 9);
    const decimalDigits = decimalParts.join('.').replace(/,/g, '').slice(0, 2);
    const hasDecimal = sanitizedValue.includes('.');

    if (!hasDecimal) {
      return `${hasLeadingMinus ? '-' : ''}${integerDigits}`;
    }

    return `${hasLeadingMinus ? '-' : ''}${integerDigits}${decimalDigits ? `.${decimalDigits}` : '.'}`;
  }

  private normalizeBreakdownInputValue(value: string): string {
    return this.normalizeCurrencyInputValue(value, 'breakdown');
  }

  isIncompleteNegativeBreakdownInput(fieldName: string): boolean {
    return this.incompleteNegativeBreakdownInputs[fieldName] === true;
  }

  private getNumericInputValue(value: any): number | null {
    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : null;
    }

    const normalizedValue = String(value ?? '').replace(/[^0-9.-]+/g, '').trim();
    if (!normalizedValue || normalizedValue === '-') {
      return null;
    }

    const numericValue = Number(normalizedValue);
    return Number.isFinite(numericValue) ? numericValue : null;
  }

  private formatCurrencyInputValue(value: string, inputType: 'breakdown' | 'amount' = 'breakdown'): string {
    const numericValue = this.getNumericInputValue(value);
    if (numericValue === null) {
      return '0.00';
    }

    return String(this.checkForNan(numericValue, inputType === 'amount' ? 'payment_amount' : undefined));
  }

  private getCalculationValue(value: any): number {
    const numericValue = this.getNumericInputValue(value);
    return numericValue !== null ? numericValue : 0;
  }

  private areAmountsEqual(leftValue: any, rightValue: any): boolean {
    const left = this.getNumericInputValue(leftValue);
    const right = this.getNumericInputValue(rightValue);

    if (left === null || right === null) {
      return false;
    }

    return new Decimal(left).equals(new Decimal(right));
  }

  get balanceBeforeTransaction(): any {
    return this.previousTransactionDataByDate || this.previousTransaction;
  }

  get totalBeforeTransaction(): any {
    return this.previousTransaction;
  }

  private normalizeEffectiveDate(value: any): string {
    const dateValue = String(value ?? '').split(' ')[0];
    const parsedDate = moment(dateValue, ['YYYY-MM-DD', 'MM/DD/YYYY'], true);
    return parsedDate.isValid() ? parsedDate.format('YYYY-MM-DD') : dateValue;
  }

  private updateEffectiveDateChangeWarning(value: any): void {
    // Hide the effective-date-changed warning for blank, invalid, future dates, or import-date-blocked dates
    if (!value || !this.isValidDate(value)) {
      this.isEffectiveDateChangedInEditMode = false;
      this.warningMessage2 = '';
      this.isApproveWarningMessage2 = false;
      this.checkBalanceAfter();
      return;
    }

    const normalized = this.normalizeEffectiveDate(value);
    const isFuture = moment(normalized).isAfter(moment().tz('America/Los_Angeles'), 'day');
    if (isFuture || this.disablePastDate) {
      this.isEffectiveDateChangedInEditMode = false;
      this.warningMessage2 = '';
      this.isApproveWarningMessage2 = false;
      this.checkBalanceAfter();
      return;
    }

    this.isEffectiveDateChangedInEditMode = this.editMode &&
      !!this.initialPaymentEffectiveDate &&
      normalized !== this.initialPaymentEffectiveDate;
    this.warningMessage2 = this.isEffectiveDateChangedInEditMode ? this.effectiveDateChangedWarningKey : '';
    if (!this.warningMessage2) {
      this.isApproveWarningMessage2 = false;
    }
    this.checkBalanceAfter();
  }

  private hasBalanceData(transaction: any): boolean {
    return !!transaction && [
      'remaining_principal_balance',
      'remaining_interest_balance',
      'remaining_late_fees_balance',
      'remaining_nsf_fees_balance',
      'remaining_other_fees_balance',
      'remaining_tax_balance',
      'remaining_down_payment_balance'
    ].some(field => transaction[field] != null);
  }

  private refreshBalanceAfter(inputValues: { [key: string]: any } = {}) {
    const balanceBefore = this.balanceBeforeTransaction;
    const balanceFields = [
      ['principal_payment', 'remaining_principal_balance'],
      ['interest_payment', 'remaining_interest_balance'],
      ['late_fees_payment', 'remaining_late_fees_balance'],
      ['nsf_fees_payment', 'remaining_nsf_fees_balance'],
      ['other_fees_payment', 'remaining_other_fees_balance'],
      ['tax_payment', 'remaining_tax_balance'],
      ['down_payment', 'remaining_down_payment_balance']
    ];

    balanceFields.forEach(([paymentField, balanceField]) => {
      const control = this.takePaymentForm.get(paymentField);
      const paymentValue = Object.prototype.hasOwnProperty.call(inputValues, paymentField)
        ? inputValues[paymentField]
        : control?.value;
      const payment = this.getCalculationValue(paymentValue);
      const before = this.getNumericInputValue(balanceBefore?.[balanceField]) ?? 0;
      this.balanceAfter[paymentField] = Number(new Decimal(before).minus(payment).toFixed(2));
    });

    this.takePaymentForm.get('payment_amount')?.updateValueAndValidity({ emitEvent: false });

    if (!this.isManualBreakdownValidationEnabled()) {
      this.isOverAmount = false;
      this.takePaymentForm.get('total_payment')?.setValue('0.00', { emitEvent: false });
      this.refreshPrincipalLimitValidation();
      return;
    }

    this.checkBalanceAfter();

    const total = this.getTotal(inputValues);
    this.takePaymentForm.get('total_payment')?.setValue(this.checkForNan(total), { emitEvent: false });
    const paymentAmount = this.getNumericInputValue(this.takePaymentForm.get('payment_amount')?.value);
    this.isOverAmount = paymentAmount === null || !new Decimal(paymentAmount).equals(new Decimal(total));
    this.takePaymentForm.controls.total_payment.markAsTouched();
    this.refreshPrincipalLimitValidation();
  }

  checkForNan(num: any, from?: string) {
    if (!isNaN(num) && num != '') {
      return this.roundToDecimal((num), 2);
    }
    else {
      if (from == 'payment_amount') {
        return null;
      }
      return parseFloat('0.00')?.toFixed(2);
    }
  }

  roundToDecimal(num: any, length: any) {
    return (new Decimal((num))).toFixed((length) || 0);
  }

  getTotal(inputValues: { [key: string]: any } = {}) {
    if (!this.isManualBreakdownValidationEnabled()) {
      return 0;
    }

    const total = [
      'principal_payment', 'interest_payment', 'late_fees_payment', 'nsf_fees_payment',
      'other_fees_payment', 'tax_payment', 'down_payment'
    ].reduce((sum, fieldName) => {
      const control = this.takePaymentForm.get(fieldName);
      if (this.incompleteNegativeBreakdownInputs[fieldName]) {
        return sum;
      }

      const value = Object.prototype.hasOwnProperty.call(inputValues, fieldName)
        ? inputValues[fieldName]
        : control?.value;
      return sum.plus(new Decimal(this.getNumericInputValue(value) ?? 0));
    }, new Decimal(0));

    return Number(total.toFixed(2));
  }

  onTakePaymentSubmit() {
    this.manageValidators();
    this.formElement.ngSubmit.emit();
    (this.formElement as any).submitted = true;
    this.onSubmit();
  }

  onSubmit() {
    this.isButtonEnabled = (this.takePaymentForm.valid && !this.isOverAmount) ? true : false;

    if (this.takePaymentForm.valid && !this.submitted && (!this.isOverAmount || !this.isManualTakePayment || !this.isManualBreakdownAllowed())) {

      this.submitted = true;
      const params = { ...this.takePaymentForm.value };
      params.loan_id = this.loanID;
      params.default_breakdown = this.isManualTakePayment ? 'NO' : 'YES';
      if (params.payment_effective_date) {
        params.payment_effective_date_local = params.payment_effective_date;
        params.payment_effective_date_pst = moment(new Date(params.payment_effective_date)).tz('America/Los_Angeles').format("YYYY-MM-DD");
      }
      if (this.loanTransactionDetails?.payment_info_code?.slug == 'WAIVE') {
        delete params.payment_received_method;
        delete params.posting_method;
      }

      if (!this.isManualBreakdownAllowed()) {
        params.default_breakdown = 'YES';
        this.isManualTakePayment = false;
      }
      params.cpi_fees_payment = 0;
      params.side_note_1_fees_payment = 0;
      params.side_note_2_fees_payment = 0;
      params.side_note_3_fees_payment = 0;
      params.side_note_4_fees_payment = 0;
      params.side_note_5_fees_payment = 0;
      if (!this.isManualTakePayment) {
        params.principal_payment = "0.00";
        params.interest_payment = "0.00";
        params.late_fees_payment = "0.00";
        params.nsf_fees_payment = "0.00";
        params.other_fees_payment = "0.00";
        params.tax_payment = "0.00";
        params.down_payment = "0.00";
        params.total_payment = "0.00";
      }
      if (this.previousTransaction?.import_transaction_date?.split(' ')[0] == params.payment_effective_date) {
        params.payment_effective_date = moment(this.previousTransaction?.import_transaction_date, "YYYY-MM-DD HH:mm:ss.SSSSSS")
          .add(1, 'minute')
          .format("YYYY-MM-DD HH:mm:ss");
      }
      const url = this.editMode ? `${PathConfig.LOAN_TRANSACTIONS}/${this.id}` : `${PathConfig.LOAN_TRANSACTIONS}`;
      const http = this.editMode ? this.httpService.put(url, params) : this.httpService.post(url, params)

      http.subscribe((response: any) => {
        this.broadCastService.broadcast(MsgConstantConfig.REFRESH_QUEUE_DETAIL_DATA);
        this.broadCastService.broadcast(MsgConstantConfig.REFRESH_LOAN_TRANSACTION_LIST);
        this.broadCastService.broadcast(MsgConstantConfig.REFRESH_ACCOUNT_HISTORY_LIST);
        this.broadCastService.broadcast(MsgConstantConfig.REFRESH_ACTIVITY);
        this.queueDetailService.triggerRefreshCPIAndSideNote();
        this.modalService.dismissAll();
        this.msgService.showSuccess(response?.message);
        this.submitted = false;
        this.isDirty = false;
      },
        (err) => {
          const msgList = Utility.getErrorMessage(err.error);
          msgList.forEach((msg) => this.msgService.showError(msg));
          this.submitted = false;
        });
    }
  }

  customValidators(type: boolean = false) {
    if (this.editMode && !this.loanDetail) {
      return;
    }

    const selectedPaymentCodeId = this.takePaymentForm?.controls?.payment_info_code_id?.value;

    this.selectedPaymentCode = this.paymentCodeList?.find((item: any) => item?.id === selectedPaymentCodeId);

    if (this.selectedPaymentCode == undefined) {
      this.selectedPaymentCode = this.loanTransactionDetails.payment_info_code;
    }
    if (this.selectedPaymentCode?.code_type === "CASH") {
      this.takePaymentForm?.controls?.payment_method_id?.setValidators([Validators.required]);
    }
    else {
      this.takePaymentForm?.controls?.payment_method_id?.clearValidators();
    }

    if (this.selectedPaymentCode?.posting_method && type == true) {
      this.takePaymentForm.patchValue({ posting_method: this.selectedPaymentCode?.posting_method ?? null });
    }

    if (this.selectedPaymentCode) {
    }

    this.takePaymentForm?.controls?.payment_method_id?.updateValueAndValidity();

    this.onPaymentInfoCodeChange();
    this.takePaymentForm?.controls?.payment_amount?.updateValueAndValidity();
    this.checkMainAmount();
  }

  onPaymentInfoCodeChange() {

    if (this.selectedPaymentCode) {

      if (!this.editMode && (this.loanDetail?.source_company_state != 'TX' || this.clientDetailService.industry_type.code != 'BUY_HERE_PAY_HERE') &&
        (this.selectedPaymentCode.activeWaterfall?.sequence?.includes('SALES_TAX') || this.selectedPaymentCode.chargeOffWaterfall?.sequence?.includes('SALES_TAX'))) {
        this.salesTaxNotAllowed = true;
      }
      else if (this.editMode && this.selectedPaymentCode.id != this.loanTransactionDetails?.payment_info_code?.id &&
        (this.loanDetail?.source_company_state != 'TX' || this.clientDetailService.industry_type.code != 'BUY_HERE_PAY_HERE') &&
        (this.selectedPaymentCode?.activeWaterfall?.sequence?.includes('SALES_TAX') || this.selectedPaymentCode?.chargeOffWaterfall?.sequence?.includes('SALES_TAX'))) {
        this.salesTaxNotAllowed = true;
      }
      else {
        this.salesTaxNotAllowed = false;
      }
    }

    this.refreshPrincipalLimitValidation();
  }

  private refreshPrincipalLimitValidation(): void {
    // These validators depend on component flags instead of only control values, so refresh both entry points explicitly.
    this.takePaymentForm?.get('payment_amount')?.updateValueAndValidity({ emitEvent: false, onlySelf: true });
    this.takePaymentForm?.get('principal_payment')?.updateValueAndValidity({ emitEvent: false, onlySelf: true });
  }

  feesRangeValidator(limit: number) {
    return (control: AbstractControl) => {
      const value = this.getNumericInputValue(control.value);
      if (value === null) {
        return null;
      }
      const isValid = value >= this.manualBreakdownRangeMin && value <= this.manualBreakdownRangeMax;
      return isValid ? null : { currencyRange: true };
    }
  }

  taxRangeValidator(control: AbstractControl) {
    const value = control.value;
    const isValid = value == '' || (value >= 0 && value <= 10000);
    return isValid ? null : { currencyRange: true, negativeBalanceAfter: false };
  }

  totalFeesRangeValidator(control: AbstractControl) {
    const value = control.value;
    const isValid = value == '' || (value >= -30000 && value <= 30000);
    return isValid ? null : { currencyRange: true };
  }

  isManualBreakdownAllowed() {
    if (this.editMode) {

      if (this.loanDetail?.status == 'ACTIVE' || this.loanDetail?.status == 'PAID-OFF') {
        if (this.selectedPaymentCode?.manual_waterfall_allowed_for_active) {
          return true;
        }
        else
          return false;
      }
      else if (this.loanDetail?.status == 'CHARGED-OFF') {
        if (this.selectedPaymentCode?.manual_waterfall_allowed_for_charge_off) {
          return true;
        }
        else
          return false;
      }
      else
        return false;
    }
    else {

      if (this.loanDetail?.status == 'ACTIVE' || this.loanDetail?.status == 'PAID-OFF') {
        if (this.selectedPaymentCode?.manual_waterfall_allowed_for_active) {
          return true;
        }
        else
          return false;
      }
      else if (this.loanDetail?.status == 'CHARGED-OFF') {
        if (this.selectedPaymentCode?.manual_waterfall_allowed_for_charge_off) {
          return true;
        }
        else
          return false;
      }
      else
        return false;
    }
  }

  currencyRangeValidator(limit: number, type?: string) {
    return (control: AbstractControl) => {
      const value = this.getNumericInputValue(control.value);
      if (value === null) {
        return null;
      }
      if (value === 0 && type == "payment_amount") {
        return { zeroNotAllowed: true };
      }
      const isManualBreakdownField = type !== 'payment_amount';
      const min = isManualBreakdownField ? this.manualBreakdownRangeMin : -limit;
      const max = isManualBreakdownField ? this.manualBreakdownRangeMax : limit;
      const isValid = value >= min && value <= max;
      return isValid ? null : { currencyRange: true };
    }
  }

  checkIfNegativeBalanceAfter() {
    this.takePaymentForm.get('tax_payment')?.updateValueAndValidity();
  }

  negativeBalanceAfter(fieldName: string) {
    return (control: AbstractControl) => {
      const value = this.balanceAfter?.[fieldName];
      if (value < 0) {
        return { negativeBalanceAfter: true, currencyRange: false };
      }
      return null;
    };
  }

  manageValidators() {
    this.manualPaymentFieldArray.forEach(fieldName => {
      this.takePaymentForm.get(fieldName)?.markAsUntouched();
    });
    if (this.isManualBreakdownValidationEnabled()) {
      this.takePaymentForm.get('principal_payment')?.setValidators([Validators.required, this.currencyRangeValidator(this.paymentAmountLimit), this.balanceAfterRangeValidator('principal_payment').bind(this), this.amountSignValidator(), this.principalBalanceLimitValidator(true)]);
      this.takePaymentForm.get('interest_payment')?.setValidators([Validators.required, this.currencyRangeValidator(this.paymentAmountLimit), this.balanceAfterRangeValidator('interest_payment').bind(this), this.amountSignValidator()]);
      this.takePaymentForm.get('late_fees_payment')?.setValidators([Validators.required, this.feesRangeValidator(this.paymentAmountLimit), this.balanceAfterRangeValidator('late_fees_payment').bind(this), this.amountSignValidator()]);
      this.takePaymentForm.get('nsf_fees_payment')?.setValidators([Validators.required, this.feesRangeValidator(this.paymentAmountLimit), this.balanceAfterRangeValidator('nsf_fees_payment').bind(this), this.amountSignValidator()]);
      this.takePaymentForm.get('other_fees_payment')?.setValidators([Validators.required, this.feesRangeValidator(this.paymentAmountLimit), this.balanceAfterRangeValidator('other_fees_payment').bind(this), this.amountSignValidator()]);
      this.takePaymentForm.get('tax_payment')?.setValidators([Validators.required, this.feesRangeValidator(this.paymentAmountLimit), this.balanceAfterRangeValidator('tax_payment').bind(this), this.amountSignValidator()]);
      this.takePaymentForm.get('down_payment')?.setValidators([Validators.required, this.feesRangeValidator(this.paymentAmountLimit), this.balanceAfterRangeValidator('down_payment').bind(this), this.amountSignValidator()]);
      this.takePaymentForm.get('total_payment')?.setValidators([Validators.required]);
    } else {
      this.manualPaymentFieldArray.forEach(fieldName => {
        this.takePaymentForm.get(fieldName)?.clearValidators();
        this.takePaymentForm.get(fieldName)?.setErrors(null);
      });
      this.disableBreakdownFields();
      this.isOverAmount = false;
    }
    this.manualPaymentFieldArray.forEach(fieldName => {
      this.takePaymentForm.get(fieldName)?.updateValueAndValidity();
    });
  }

  private isManualBreakdownValidationEnabled(): boolean {
    return this.isManualTakePayment && this.isManualBreakdownAllowed();
  }

  breakdownValidator(isManualTakePayment: () => boolean, isManualBreakdownAllowed: () => boolean) {
    return (control: AbstractControl) => {
      const value = control?.value;
      if ((!isManualTakePayment() || !isManualBreakdownAllowed()) && value < 0) {
        return { invalidBreakdownNegative: true };
      }
      return null;
    };
  }

  private getPrincipalBeforeBalance(): number | null {
    const principalFromBalanceBefore = this.getNumericInputValue(this.balanceBeforeTransaction?.remaining_principal_balance);
    if (principalFromBalanceBefore !== null) {
      return principalFromBalanceBefore;
    }

    // Edit-mode payloads can carry the pre-edit baseline on the nested previous_transaction chain even when the live input differs.
    const principalFromEditPreviousTransaction = this.getNumericInputValue(this.transactionDetails?.previous_transaction?.remaining_principal_balance);
    if (this.editMode && principalFromEditPreviousTransaction !== null) {
      return principalFromEditPreviousTransaction;
    }

    if (this.editMode) {
      // As a final fallback, reconstruct the before-balance by undoing the transaction's original principal impact.
      const currentPrincipal = this.getNumericInputValue(this.loanDetail?.current_principal);
      const previousPrincipalPayment = this.getNumericInputValue(this.loanTransactionDetails?.principal_payment);
      if (currentPrincipal !== null && previousPrincipalPayment !== null) {
        return Number(new Decimal(currentPrincipal).plus(previousPrincipalPayment).toFixed(2));
      }
    }

    return this.getNumericInputValue(this.totalBeforeTransaction?.remaining_principal_balance);
  }

  private getProjectedPrincipalBalance(paymentAmountSource: any): number | null {
    const principalBeforeBalance = this.getPrincipalBeforeBalance();
    const principalPayment = this.getNumericInputValue(paymentAmountSource);

    if (principalBeforeBalance === null || principalPayment === null) {
      return null;
    }

    return Number(new Decimal(principalBeforeBalance).minus(principalPayment).toFixed(2));
  }

  private getProjectedCurrentPrincipalBalanceForEdit(paymentAmountSource: any): number | null {
    if (!this.editMode) {
      return null;
    }

    const currentPrincipal = this.getNumericInputValue(this.loanDetail?.current_principal);
    const nextPrincipalImpact = this.getNumericInputValue(paymentAmountSource);
    const previousPrincipalImpact = this.getNumericInputValue(
      this.isManualTakePayment
        ? this.loanTransactionDetails?.principal_payment
        : this.loanTransactionDetails?.payment_amount
    );

    if (currentPrincipal === null || nextPrincipalImpact === null || previousPrincipalImpact === null) {
      return null;
    }

    // In edit mode, the new value replaces the saved transaction impact. Undo the
    // saved impact first, then apply the new one to project the resulting principal.
    const delta = new Decimal(previousPrincipalImpact).minus(nextPrincipalImpact);
    return Number(new Decimal(currentPrincipal).plus(delta).toFixed(2));
  }

  private getPrincipalBalanceLimitType(paymentAmountSource: any): 'min' | 'max' | null {
    const projectedCurrentPrincipalBalance = this.getProjectedCurrentPrincipalBalanceForEdit(paymentAmountSource);
    const currentPrincipalBalance = this.getNumericInputValue(this.loanDetail?.current_principal);
    const nextPrincipalImpact = this.getNumericInputValue(paymentAmountSource);
    const projectedCurrentPrincipalBalanceFromInput = (currentPrincipalBalance !== null && nextPrincipalImpact !== null)
      ? Number(new Decimal(currentPrincipalBalance).minus(nextPrincipalImpact).toFixed(2))
      : null;
    // Add mode receives the current principal from the parent through loanDetail.
    // Edit mode must use the replacement projection above so the original payment is not counted twice.
    const projectedBalance = this.editMode && projectedCurrentPrincipalBalance !== null
      ? projectedCurrentPrincipalBalance
      : this.editMode ? null : projectedCurrentPrincipalBalanceFromInput;

    if (currentPrincipalBalance === null || projectedBalance === null) {
      return null;
    }

    const minLimit = -this.paymentAmountLimit;
    const maxLimit = this.principalBalanceUpperLimit;
    // A balance inside the range may reach or cross a threshold. Once it is already
    // beyond a threshold, block only movement farther away from the allowed range.
    if (currentPrincipalBalance <= minLimit) {
      if (projectedBalance < currentPrincipalBalance) {
        return 'min';
      }
    }

    if (currentPrincipalBalance >= maxLimit) {
      if (projectedBalance > currentPrincipalBalance) {
        return 'max';
      }
    }

    return null;
  }

  private hasPrincipalBalanceLimitReached(paymentAmountSource: any): boolean {
    return this.getPrincipalBalanceLimitType(paymentAmountSource) !== null;
  }

  private hasOtherValidationErrors(): boolean {
    if (!this.takePaymentForm) {
      return false;
    }

    const controls = Object.values(this.takePaymentForm.controls || {});
    const hasControlErrors = controls.some((control: AbstractControl) => {
      if (control?.disabled || !control?.errors) {
        return false;
      }

      return Object.keys(control.errors).some((key) => key !== 'principalBalanceLimitReached');
    });

    if (hasControlErrors) {
      return true;
    }

    if (!this.takePaymentForm.errors) {
      return false;
    }

    return Object.keys(this.takePaymentForm.errors).some((key) => key !== 'principalBalanceLimitReached');
  }

  private shouldApplyPrincipalBalanceLimitValidation(): boolean {
    if (!this.takePaymentForm) {
      return false;
    }

    return !this.hasOtherValidationErrors()
      && !this.isOverAmount
      && !this.isFutureDate
      && !this.disablePastDate
      && !this.salesTaxNotAllowed;
  }

  principalBalanceLimitValidator(applyWhenManual: boolean) {
    return (control: AbstractControl) => {
      if (this.isManualTakePayment !== applyWhenManual) {
        return null;
      }

      if (!this.shouldApplyPrincipalBalanceLimitValidation()) {
        return null;
      }

      const hasReachedLimit = this.hasPrincipalBalanceLimitReached(control.value);

      return hasReachedLimit ? { principalBalanceLimitReached: true } : null;
    };
  }

  get isDefaultBreakdownPrincipalLimitReached(): boolean {
    if (!this.shouldApplyPrincipalBalanceLimitValidation()) {
      return false;
    }

    const paymentAmountSource = this.isManualTakePayment
      ? this.takePaymentForm?.get('principal_payment')?.value
      : this.takePaymentForm?.get('payment_amount')?.value;

    return this.hasPrincipalBalanceLimitReached(paymentAmountSource);
  }

  get principalBalanceLimitErrorMessage(): string {
    const paymentAmountSource = this.isManualTakePayment
      ? this.takePaymentForm?.get('principal_payment')?.value
      : this.takePaymentForm?.get('payment_amount')?.value;
    const limitType = this.getPrincipalBalanceLimitType(paymentAmountSource);
    // Keep the displayed balance consistent with the limit calculation in both modes.
    // In add mode this value is supplied by the parent through loanDetail.
    const principalBalance = this.getNumericInputValue(this.loanDetail?.current_principal)
      ?? this.getPrincipalBeforeBalance()
      ?? 0;
    const formattedBalance = this.currencyPipe.transform(principalBalance, 'USD', 'symbol', '1.2-2') ?? '$0.00';
    const amountLabelKey = this.isManualTakePayment ? 'Principal Payment' : 'Payment Amount';
    const amountLabel = this.translateService.instant(amountLabelKey);

    if (limitType === 'max') {
      return this.translateService.instant(
        'TAKE_PAYMENT_PRINCIPAL_LIMIT_MAX',
        { currentBalance: formattedBalance, maximumLimit: '$100,000,000.00', amountLabel }
      );
    }

    return this.translateService.instant(
      'TAKE_PAYMENT_PRINCIPAL_LIMIT_MIN',
      { currentBalance: formattedBalance, minimumLimit: '-$100,000,000.00', amountLabel }
    );
  }

  balanceAfterRangeValidator(fieldName: string) {
    return (control: AbstractControl) => {
      if (!this.isManualBreakdownValidationEnabled()) {
        return null;
      }
      // Before/After balances are hidden while the effective date is being changed/recalculated, so don't validate against them yet.
      if (this.isEffectiveDateChangedInEditMode || this.isLoadingEffectiveDateBalances) {
        return null;
      }
      if (this.getNumericInputValue(control.value) === null) {
        return null;
      }
      const value = this.balanceAfter?.[fieldName];
      const min = fieldName === 'principal_payment' ? -this.paymentAmountLimit : 0;
      const max = this.paymentAmountLimit;
      const isValid = value >= min && value <= max;
      return isValid ? null : {
        invalidBalanceAfterRange: {
          message: `${this.translateService.instant('Balance after must be between')} ${this.currencyPipe.transform(min, 'USD', 'symbol', '1.2-2')} ${this.translateService.instant('and')} ${this.currencyPipe.transform(max, 'USD', 'symbol', '1.2-2')}`
        }
      };
    };
  }

  checkBalanceAfter() {
    if (!this.isManualBreakdownValidationEnabled()) {
      return;
    }

    const balanceAfterFields = ['principal_payment', 'interest_payment', 'late_fees_payment', 'nsf_fees_payment', 'other_fees_payment', 'tax_payment', 'down_payment'];
    balanceAfterFields.forEach(fieldName => {
      this.takePaymentForm.get(fieldName)?.updateValueAndValidity();
    });
  }

  validateAmountForWarning(selectedDate?: any) { //for warning message when payment amount exceeds total remaining balance
    if (this.isLoadingEffectiveDateBalances) {
      this.isShowWarning = false;
      this.warningMessage = '';
      return;
    }

    if (!this.takePaymentForm?.get('payment_amount')?.value || this.takePaymentForm?.get('payment_effective_date')?.invalid) {
      this.isShowWarning = false;
      this.warningMessage = '';
      return;
    };

    const effectiveTotalBalance = this.getPreviousTransactionPositiveTotalRemaining(this.balanceBeforeTransaction) || 0;
    const enteredAmount =
      Number(this.takePaymentForm.get('payment_amount')?.value) || 0;
    const effectiveCurrentPrincipal = Number((effectiveTotalBalance).toFixed(2));
    const formattedBalance = this.currencyPipe.transform(
      effectiveTotalBalance,
      'USD',
      'symbol',
      '1.2-2'
    );


    const shouldWarn = (enteredAmount > effectiveCurrentPrincipal) || (effectiveTotalBalance <= 0);
    if (shouldWarn) {
      if (effectiveTotalBalance <= 0) {
        this.warningMessage = `${this.translateService.instant('There is no remaining balance')} (${this.currencyPipe.transform((this.balanceBeforeTransaction?.remaining_total_balance ?? 0), 'USD', 'symbol', '1.2-2')}). ${this.translateService.instant('Are you sure you want to post this payment?')}`
      } else {
        this.warningMessage = `${this.translateService.instant('You are trying to post a payment which exceeds the total remaining balance owed')} (${formattedBalance}). ${this.translateService.instant('Are you sure you want to proceed?')}`
      }
    } else {
      this.warningMessage = '';
    }
    this.isShowWarning = shouldWarn;
  }

  get showTotalRemainingWarning(): boolean {
    if (this.editMode && !this.takePaymentForm.dirty) {
      return false;
    }

    const isShow = (this.isShowWarning) &&
      !this.isDefaultBreakdownPrincipalLimitReached &&
      !this.isLoadingEffectiveDateBalances &&
      !this.isFutureDate &&
      !this.salesTaxNotAllowed &&
      !this.disablePastDate &&
      !!this.takePaymentForm?.get('payment_amount')?.value &&
      !(this.takePaymentForm?.get('payment_amount')?.value === '-') &&
      !(this.takePaymentForm?.get('payment_amount')?.value === '.') &&
      !(this.takePaymentForm?.get('payment_amount')?.value === '-.') &&
      this.takePaymentForm.valid &&
      (!this.isManualTakePayment || !this.isOverAmount || !this.isManualBreakdownAllowed());
    if (!isShow && this.isApprove) {
      this.isApprove = false;
    }
    return isShow;
  }

  get showEffectiveDateChangeWarning(): boolean {
    const isShow = !!this.warningMessage2 && !this.isDefaultBreakdownPrincipalLimitReached && !this.isLoadingEffectiveDateBalances && this.editMode && this.isEffectiveDateChangedInEditMode && this.takePaymentForm.valid && !this.disablePastDate
      && !this.isFutureDate && !this.salesTaxNotAllowed && !!this.takePaymentForm?.get('payment_amount')?.value && !this.isOverAmount;
    if (!isShow && this.isApproveWarningMessage2) {
      this.isApproveWarningMessage2 = false;
    }
    return isShow;
  }


  async getPreviousTransactionByEffectiveDate(selectedEffectiveDate?: string, requestId?: number) {
    return new Promise((resolve, reject) => {
      const url = `${PathConfig.LOAN_TRANSACTIONS_BY_EFFECTIVE_DATE}?loan_id=${this.loanDetail?.id}&payment_effective_date=${selectedEffectiveDate}`;
      this.httpService.get(url).subscribe((res) => {
        if (requestId === this.effectiveDateRequestId) {
          this.previousTransactionDataByDate = this.hasBalanceData(res) ? res : null;
          this.refreshBalanceAfter();
        }
        resolve(res);
      }, (err) => {
        if (requestId === this.effectiveDateRequestId) {
          this.msgService.showError(this.translateService.instant('Failed to fetch previous transaction by effective date'));
          this.isLoadingEffectiveDateBalances = false;
          this.isShowWarning = false;
          this.warningMessage = '';
          this.isApprove = false;
        }
        reject(err);
      });
    });
  }

  isValidDate(value: string): boolean {
    if (!value) return false;

    const trimmedValue = value.trim();

    const m1 = moment(trimmedValue, 'MM/DD/YYYY', true);
    const m2 = moment(trimmedValue, 'YYYY-MM-DD', true);

    const parsedDate = m1.isValid() ? m1 : (m2.isValid() ? m2 : null);
    const year = parsedDate?.year() || 0;

    if (!parsedDate || year > 9999) return false;

    return true;
  }

  getPreviousTransactionPositiveTotalRemaining(data: any) {
    const totalRemainingBalance = [
      data?.remaining_principal_balance,
      data?.remaining_interest_balance,
      data?.remaining_late_fees_balance,
      data?.remaining_nsf_fees_balance,
      data?.remaining_other_fees_balance,
      data?.remaining_tax_balance,
      data?.side_note_payments?.remaining_cpi_balance,
      data?.side_note_payments?.remaining_side_note_1_balance,
      data?.side_note_payments?.remaining_side_note_2_balance,
      data?.side_note_payments?.remaining_side_note_3_balance,
      data?.side_note_payments?.remaining_side_note_4_balance,
      data?.side_note_payments?.remaining_side_note_5_balance,
      data?.remaining_down_payment_balance
    ].reduce((sum, value) => sum + Math.max(0, Number(value) || 0), 0);
    return totalRemainingBalance;
  }

  get isAllowNegativeInInput() {
    return Number(String(this.takePaymentForm?.get('payment_amount')?.value ?? 0).replace(/,/g, '')) < 0;
  }

  get manualBreakdownRangeMin(): number {
    return this.isAllowNegativeInInput ? -this.paymentAmountLimit : 0;
  }

  get manualBreakdownRangeMax(): number {
    return this.isAllowNegativeInInput ? 0 : this.paymentAmountLimit;
  }

  amountSignValidator() {
    return (control: AbstractControl) => {
      const paymentAmount = Number(String(this.takePaymentForm?.get('payment_amount')?.value ?? 0).replace(/,/g, ''));
      const value = this.getNumericInputValue(control.value);

      if (paymentAmount < 0 && value !== null && value > 0) {
        return {
          invalidPaymentSign: {
            message: `${this.translateService.instant('Value must be negative when payment amount is negative')}`
          }
        };
      }

      if (paymentAmount > 0 && value !== null && value < 0) {
        return {
          invalidPaymentSign: {
            message: `${this.translateService.instant('Value must be positive when payment amount is positive')}`
          }
        };
      }

      return null;
    };
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}